import {
  type DtoAsset,
  type DtoCreateAssetReq,
  type DtoGetBorrowerAssetsResp,
  type DtoUpdateAssetReq,
  type DomainAssetType,
} from "@porchpass/api-client";
import { requiredField } from "./required";

export type AssetFormData = {
  id?: string;
  account_type?: DomainAssetType;
  balance_amount?: string;
  institution_name?: string;
};

export type AssetListFormData = {
  financialAccounts: AssetFormData[];
};

export function toCreateAssetReq(data: AssetFormData): DtoCreateAssetReq {
  return {
    asset_type: requiredField(data.account_type, "account_type"),
    balance_amount: parseInt(
      requiredField(data.balance_amount, "balance_amount"),
    ),
    institution_name: requiredField(data.institution_name, "institution_name"),
  };
}

export function toUpdateAssetReq(data: AssetFormData): DtoUpdateAssetReq {
  return {
    asset_type: requiredField(data.account_type, "account_type"),
    balance_amount: parseInt(
      requiredField(data.balance_amount, "balance_amount"),
    ),
    institution_name: requiredField(data.institution_name, "institution_name"),
  };
}

export function fromAssetsList(
  data: DtoGetBorrowerAssetsResp,
): AssetListFormData {
  const mappedAccountData = (data.assets ?? []).map((account) =>
    mapAssetToForm(account),
  );

  return { financialAccounts: mappedAccountData };
}

function mapAssetToForm(account: DtoAsset): AssetFormData {
  return {
    ...account,
    account_type: account.asset_type,
    balance_amount: String(account.balance_amount),
  };
}
